import React from 'react';

const year = new Date().getFullYear();

const Footer = () => {
    return (
        <footer className='footer'>
            <p className='footer'>
                &copy; {year} Static Lab.&nbsp; All Rights Reserved.
            </p>
        </footer>
    );
};

export default Footer;